import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-purchase-content-daily',
  templateUrl: './manual-purchase-content-daily.component.html',
  styleUrls: ['./manual-purchase-content-daily.component.css'],
  standalone: false,
})
export class ManualPurchaseContentDailyComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly selectPurchaseDailyDialogLink: string = AppConst.ROUTING_LINK_MANUAL_SELECT_PURCHASE_CONTENT_DAILY_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
